// LiveStreamSettingButton.js
'use strict';
import { connect } from 'react-redux';

import LiveStreamSettingButton from '../component/LiveStreamSettingButton.jsx';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { LIVESTREAM_LOW_DEFINITION_VIDEO_IDS } from '../RemoteConfigKeys.js';

import addModal from '../action/addModal.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getModalData from '../selector/getModalData.js';

const mapStateToProps = (state, { streamId }) => {
  const lowDefinitionVideoIds = getRemoteConfigData(
    state,
    LIVESTREAM_LOW_DEFINITION_VIDEO_IDS
  );
  return {
    lowDefinitionVideoIds,
    qualityFor: getLiveStreamData(state, [streamId], 'qualityFor'),
    menuModalStatus: getModalData(state, 'LiveStreamSettingMenu', 'status'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openModal: ({ id }) =>
      dispatch(
        addModal({ id, isHigherThanAll: true, transitionStatus: 'coming' })
      ),
    updateShouldLogVideoResolution: ({ shouldLogVideoResolution }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['player'],
          data: {
            shouldLogVideoResolution,
          },
        },
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamSettingButton);
